import arraySplitter from './array-splitter';
import snake2camel from './snake2camel';



const helpers = {
  arraySplitter: arraySplitter,
  snake2camel: snake2camel,
  firstUpper: str => {
    if (typeof str === 'number') str = String(str);
    str = typeof str === 'string' ? str : '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  cloneJson(data) { return JSON.parse(JSON.stringify(data)) },
};



export default helpers;



// WEBPACK FOOTER //
// ./src/js/helpers/index.js